import TOCJourney from "@adapters/features/TOCJourney/Repository/TOCJourney";
import MandateFlowRepository from "@adapters/features/MandateFlow/Repository/MandateFlow";
import PaymentFlowRepository from "@adapters/features/PaymentFlow/Repository/PaymentFlow";
import { accountDetails } from "@mainDi/webDi";
import { qouteStream } from "@mainDi/streamerDi";
export default (function (http) {
    return {
        tocJourney: new TOCJourney(http, accountDetails),
        mandate: new MandateFlowRepository(http, accountDetails),
        payment: new PaymentFlowRepository(http, accountDetails),
        quoteStream: qouteStream,
    };
});
